import React, { useCallback } from "react";
import { InvoiceSource } from "@common/types/invoice";
import { EntityFilterCombobox } from "@components/entity/EntityFilter/EntityFilterCombobox";
import { Button } from "@design-system/Button/Button";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import {
    FilterTabs,
    FiltersChangeFn,
} from "@components/pageHeader/filters/lib";
import { useInvoicesView } from "contexts/InvoicesViewContext";

const PICKER_FILTERS = [
    FilterTabs.INVOICE_STATUSES,
    FilterTabs.COUNTERPARTY,
    FilterTabs.AMOUNT,
    FilterTabs.OVERDUE,
];

interface Props {
    lockedInvoiceSources?: InvoiceSource[];
    onCreateBlankTemplate?: () => void;
}

export const InvoicesDrillDownPickerHeader: React.FC<Props> = ({
    lockedInvoiceSources,
    onCreateBlankTemplate,
}) => {
    const { filters, setFilters } = useInvoicesView();

    const handleFiltersChange = useCallback<FiltersChangeFn>(
        (value) => {
            setFilters((prev) => ({
                ...prev,
                ...value,
                ...(lockedInvoiceSources
                    ? { invoiceSources: lockedInvoiceSources }
                    : {}),
            }));
        },
        [lockedInvoiceSources, setFilters],
    );

    const handleSearchChange = useCallback(
        (value: string | undefined) => {
            handleFiltersChange({ search: value ?? "" });
        },
        [handleFiltersChange],
    );

    return (
        <TablePageHeader
            search={filters?.search}
            onSearchChange={handleSearchChange}
            filters={filters ?? {}}
            onFiltersChange={handleFiltersChange}
            availableFilters={PICKER_FILTERS}
            hideClearButton
            isFullPage
            searchPlaceholder="Search invoices..."
            counterpartyEntityLabel="Customer"
        >
            <EntityFilterCombobox
                filters={filters ?? {}}
                onChange={handleFiltersChange}
                onlyBusiness
                showLabel={false}
            />
            {onCreateBlankTemplate && (
                <Button
                    variant="primary"
                    size="md"
                    onClick={onCreateBlankTemplate}
                >
                    Create blank template
                </Button>
            )}
        </TablePageHeader>
    );
};
